import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import {
    ThemeProvider
  } from '@material-ui/core/styles';

import { Dashboard, Devices, AddDevice, AssetProfile, MiniDrawer, SimpleLayout, MyDevices, CategoriesAdmin, Categories, Category, NewCategory, AssignmentList, Login, NotFound } from './components';
import { Users, AdminUsers } from './components/Admin';
import { theme } from './theme';
import { isAdmin } from './utils';

function App() {
  const { user } = useSelector((state) => state.auth);

  const router = useMemo(() => {
    if (isAdmin(user.scope)) {
      return createBrowserRouter([
        {
          path: "/",
          element: <MiniDrawer />,
          children: [
            { index: true, element: <Dashboard /> },
            { path: "/login", exact: true, element: <Login /> },
            { path: "/admin/users", element: <Users /> },
            { path: "/admin/admin-users", element: <AdminUsers /> },
            { path: "/assignments", element: <AssignmentList /> },
            { path: "/category/:assetType/asset/:assetId", element: <AssetProfile /> },
            { path: "/category/:assetType/asset/add", element: <AddDevice /> },
            { path: "/category/:assetType", element: <Devices />},
            {
              path: "/admin/categories",
              element: <CategoriesAdmin />,
              children: [
                { index: true, element: <Categories/>},
                { path: "add", element: <NewCategory isNew={true} />},
                { path: "category/add", element: <Category isNew={true} />},
                { path: "category/:assetType", element: <Category />},
              ],
            },
            { path: "*", element: <NotFound /> },
          ],
        },
      ]);
    }

    return createBrowserRouter([
      {
        path: "/",
        element: <SimpleLayout />,
        children: [
          { index: true, element: <MyDevices /> },
          { path: "/login", exact: true, element: <Login /> },
          { path: "/device/:assetType/asset/:assetId", element: <AssetProfile /> },
          { path: "*", element: <NotFound /> },
        ],
      },
    ]);
  }, [user.scope]);

    return (
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      );
}

export default App;
